import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import ACTIONS from '../../../store/actions';
import load from './load';
export var changeFilter = function changeFilter(e, props) {
  return function (dispatch, getState) {
    var id = props.id,
        filter = props.filter,
        by = props.by;
    var state = getState();
    var view = state.grid.views[id];
    var newFilter = view.filter;
    var newBy = view.by;
    if (typeof filter !== 'undefined') newFilter = filter;
    if (typeof by !== 'undefined') newBy = by;
    var newSortColumn = props.grid.columns.find(function (c) {
      return c.id === newBy;
    });
    var newAll = {}; //reset

    var newView = {
      id: id,
      all: newAll,
      by: newBy,
      filter: newFilter,
      page: 0
    };

    if (newSortColumn && newSortColumn.filterable) {
      return dispatch(load(_objectSpread({}, props, newView)));
    } else {
      return dispatch({
        type: ACTIONS.GRID_VIEW_SET,
        view: newView
      });
    }
  };
};
export default changeFilter;